 
function isNullish(value) {
    return value === null || value === undefined || value === '';
}
 
class GiftDispatcher extends HTMLElement {
    constructor() {
        super();
        this.gifts = this.querySelectorAll('input[type="hidden"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cartItems = this.cart.querySelector('cart-items') || this.cart.querySelector('cart-drawer-items');
 
        this.cartURLs = {
            add: `${routes.cart_add_url}.js`,
            change: `${routes.cart_change_url}.js`,
            update: `${routes.cart_update_url}.js`,
            cart: `${routes.cart_url}.js`,
        };

        // delete permission to prevent from double cart refresh
        this.deletePermission = true;
    }
 
    connectedCallback() {
        this.listenEvents();
    }
 
    disconnectedCallback() {
        this.removeEvents();
    }
 
    listenEvents() {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            this.getCart().then(cart => { this.validateConditions(cart)});
        });
    }
 
    removeEvents() {}
 
    async getCart() {
        return fetch(this.cartURLs.cart, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => response.json())
        .then(response => {
            return response;
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
 
    validateConditions(cart) {
        for (const gift of this.gifts) {
 
            if(isNullish(gift.dataset.variantId) || isNullish(gift.dataset.tierType)) return;

            const variantId = parseInt(gift.dataset.variantId);
            const discountCode = gift.dataset.discountCode;
            const codeIsValid = this.validDiscountCode(cart, discountCode);
            const isAlreadyOnCart = this.isAlreadyOnCart(cart, variantId);

            if(codeIsValid && !isAlreadyOnCart && cart.total_price > 0) {
                this.addGiftToCart(variantId);
            }
            else if(isAlreadyOnCart){
                if(this.deletePermission) {
                    this.deletePermission = false;

                    const buttonRemove = document.querySelector(`cart-remove-button [data-variant-id="${variantId}"]`);
                    const cartRemoveButton = buttonRemove.closest('cart-remove-button');
                    this.cartItems.updateQuantity(parseInt(cartRemoveButton.dataset.index), 0);

                    setTimeout(() => {
                        this.deletePermission = true;
                    }, 2000);
                }
            }
        }
    }

    validDiscountCode(cart, discountCode) {
        console.log(cart.discount_codes)
        if(!cart.discount_codes) return false;

        return cart.discount_codes.some((code) => code.code === discountCode);
    }
 
    isAlreadyOnCart(cart, variantId) {
        if(!cart.items) return false;

        return cart.items.some((item) => item.variant_id == variantId);
    }
 
    updateCart(response) {
        if(this.cart) {
            this.cart.renderContents(response);
        }
    }
 
    async addGiftToCart(variantId) {
        let bodyConfig = JSON.stringify({
            items: [
                {
                    id: variantId,
                    quantity: 1,
                },
            ],
        });

        if(this.cart) {
            bodyConfig = JSON.stringify({
                items: [
                    {
                        id: variantId,
                        quantity: 1,
                    },
                ],
                sections: this.cart.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname
            });
        }
 
        return fetch(this.cartURLs.add, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodyConfig, 
        })
        .then((response) => response.json())
        .then((response) => {
            this.updateCart(response);
        }).catch((error) => {
            console.error('Error adding gift to cart:', error);
        });
    }
}
 
customElements.define('gift-dispatcher', GiftDispatcher);